import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';

// Attributes
import phoneNumberAttr from '@drivesally/sally-fn/lib/driver/attributes/phone_number.attribute.driver';

// Components
import {P, Icon} from '@drivesally/sally-ui';
import SpotlightRow from '../SpotlightRow/SpotlightRow';
import Container from './components/Container';
import SearchContainer from './components/SearchContainer';
import SearchIcon from './components/SearchIcon';
import SearchIconContainer from './components/SearchIconContainer';
import CloseIcon from './components/CloseIcon';
import Input from './components/Input';
import Content from './components/Content';
import ContentHeader from './components/ContentHeader';
import NoResults from './components/NoResults';

class Spotlight extends Component {
  static propTypes = {
    drivers: PropTypes.array,
    loading: PropTypes.bool,
    onClose: PropTypes.func,
    onDriver: PropTypes.func,
    onEscape: PropTypes.func,
    onSearch: PropTypes.func,
    onVehicle: PropTypes.func,
    search: PropTypes.string,
    showResults: PropTypes.bool,
    vehicles: PropTypes.array,
  };

  componentDidMount() {
    if (this.props.visible) this.init();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) this.init();
  }

  init = () => setTimeout(this.focus, 150);

  focus = () => {
    if (!this.input) return;
    this.input.focus();
  };

  handleClickOutside = () => {
    this.props.onClose();
  };

  onChange = (e) => {
    this.props.onSearch(e.target.value);
  };

  onKeyDown = (e) => {
    if (e.key === 'Escape') {
      this.props.onEscape();
      e.preventDefault();
      return false;
    }
  };

  onRef = (input) => {
    this.input = input;
  };

  render() {
    const {
      drivers,
      loading,
      onDriver,
      onEscape,
      onVehicle,
      search,
      showResults,
      vehicles,
    } = this.props;
    return (
      <Container showResults={showResults}>
        <SearchContainer>
          <SearchIconContainer loading={loading}>
            <SearchIcon
              icon={loading ? 'loading2' : 'search1'}
              spin={loading}
            />
          </SearchIconContainer>
          <Input
            innerRef={this.onRef}
            value={search}
            onKeyDown={this.onKeyDown}
            onChange={this.onChange}
            placeholder="Search"
          />
          <CloseIcon onClick={onEscape}>
            <Icon icon="close" />
          </CloseIcon>
        </SearchContainer>
        <Content>
          {!loading && !drivers.length && !vehicles.length && (
            <NoResults>
              <P theme="darkGrey" size="2">
                No Results found
              </P>
            </NoResults>
          )}
          {!!drivers.length && (
            <Fragment>
              <ContentHeader>Drivers</ContentHeader>
              {drivers.map((driver) => (
                <SpotlightRow
                  key={driver.id}
                  title={`${driver.first_name} ${driver.last_name}`}
                  addon1={driver.fhv_license_number || '-'}
                  addon2={phoneNumberAttr(driver.phone_number).display.format()}
                  onClick={onDriver(driver)}
                />
              ))}
            </Fragment>
          )}
          {!!vehicles.length && (
            <Fragment>
              <ContentHeader>Vehicles</ContentHeader>
              {vehicles.map((vehicle) => (
                <SpotlightRow
                  key={vehicle.id}
                  title={vehicle.svid}
                  addon1={vehicle.plate}
                  addon2={vehicle.vin}
                  onClick={onVehicle(vehicle)}
                />
              ))}
            </Fragment>
          )}
        </Content>
      </Container>
    );
  }
}

export default onClickOutside(Spotlight);
